const transfer_moneyIcon = "/assets_default/icons/transfer_money.svg"
const walletIcon = "/assets_default/icons/wallet.svg"
const savingIcon = "/assets_default/icons/saving.svg"
const advance_moneyIcon = "/assets_default/icons/advance_money.svg"
const thumbs_upIcon = "/assets_default/icons/thumbs_up.svg"
const interestrateIcon =  "/assets_default/icons/interestrate.svg"
const percentIcon = "/assets_default/icons/percent.svg"

const baasIcon = "/assets_default/icons/baas.svg"
const companyIcon = "/assets_default/icons/company.svg"
const corporationIcon = "/assets_default/icons/corporation.svg"
const documentIcon = "/assets_default/icons/document.svg"

const minnaIcon = "/assets_default/icons/minna.svg"
const editIcon = "/assets_default/icons/edit.svg"
const dictionaryIcon = "/assets_default/icons/dictionary.svg"
const lockicon = "/assets_default/icons/lock.svg"

const helpIcon = "/assets_default/icons/help.svg"
const chatIcon = "/assets_default/icons/chat.svg"
const mobileIcon = "/assets_default/icons/mobile.svg"
const infomationIcon = "/assets_default/icons/infomation.svg"

const logo_x = "/assets_default/icons/sns/logo_x-white.svg"
const logo_facebook = "/assets_default/icons/sns/logo_facebook-white.svg"
const logo_instagram = "/assets_default/icons/sns/logo_instagram-white.svg"
const logo_youtube = "/assets_default/icons/sns/logo_youtube-white.svg"
const logo_note = "/assets_default/icons/sns/logo_note-white.svg"

export const breakPoint = 780
export const headerBreakPoint = 760
// /business/PC・SPデザインのブレイクポイント
export const bizBreakpoint = 896
//　税引後係数
export const TAX_COEFFICIENT = 0.79685;
// 金利：貯蓄預金
export const SavingInterestRateNumber = 0.6 //旧0.37
// 貯蓄預金：税引後 小数点第4位を切り捨て
export const AfterTaxSavingInterestRateNumber = Math.floor(SavingInterestRateNumber * TAX_COEFFICIENT * 1000) / 1000;
// 金利：貯蓄預金_プレミアム
export const SavingPremiumInterstRateNumber = 0.8 //旧0.57
// 貯蓄預金_プレミアム：税引後 小数点第4位を切り捨て
export const AfterTaxSavingPremiumInterstRateNumber = Math.floor(SavingPremiumInterstRateNumber * TAX_COEFFICIENT * 1000) / 1000;
// 金利：普通預金
export const AllDepositNumber = 0.5 //旧0.30
// 普通預金：税引後 小数点第4位を切り捨て
export const AfterTaxAllDepositNumber = Math.floor(AllDepositNumber * TAX_COEFFICIENT * 1000) / 1000;

export const subNavigation = [
  {
    iconPath: corporationIcon,
    label:"法人のお客さま",
    href:"/business/",
    sendSPID:"common-sp-hamburger",
    sendPCID:"common-pc-hamburger",
    blank: true
  },
  {
    iconPath: baasIcon,
    label:"BaaSとは",
    href:"https://baas.minna-no-ginko.com/",
    sendSPID:"common-sp-hamburger",
    sendPCID:"common-pc-hamburger",
    blank: true
  },
  {
    iconPath: companyIcon,
    label:"会社概要",
    href:"https://corporate.minna-no-ginko.com/",
    sendSPID:"common-sp-hamburger",
    sendPCID:"common-pc-hamburger",
    blank: true
  },
  {
    iconPath: documentIcon,
    label:"ニュース",
    href:"https://corporate.minna-no-ginko.com/information/",
    sendSPID:"common-sp-hamburger",
    sendPCID:"common-pc-hamburger",
    blank: true
  },
  {
    footer: true,
    label:"採用情報",
    href:"https://corporate.minna-no-ginko.com/careers/",
    sendSPID:"common-sp-hamburger",
    sendPCID:"common-pc-hamburger",
    blank: true
  },
]

export const ServiceMenu = [
  {
    icon:"transfer_money",
    iconPath:transfer_moneyIcon,
    label:"入出金",
    caption:"ATM・振込・ことら送金",
    childMenu: [
      {
        href:"/service/atm/",
        sendSPID:"common-sp-header-service",
        sendPCID:"common-pc-header-service",
        label:"ATM",
        caption:"キャッシュカード不要で現金を入出金",
      },
      {
        href:"/service/transfer/",
        sendSPID:"common-sp-header-service",
        sendPCID:"common-pc-header-service",
        label:"振込・ことら送金",
        caption:"みんなの銀行間の振込とことら送金なら手数料無料",
      }
    ]
  },
  {
    icon:"wallet",
    iconPath:walletIcon,
    label:"支払う",
    caption:"デビットカード・請求書払い・A2A決済",
    childMenu: [
      {
        href:"/service/debit-card/",
        sendSPID:"common-sp-header-service",
        sendPCID:"common-pc-header-service",
        label:"デビットカード",
        caption:"スマートフォン決済もネットショッピングもできる",
      },
      {
        href:"/service/invoice/",
        sendSPID:"common-sp-header-service",
        sendPCID:"common-pc-header-service",
        label:"請求書払い",
        caption:"紙の請求書もいつでもスマホ完結",
      },
      {
        href:"/service/a2a/",
        sendSPID:"common-sp-header-service",
        sendPCID:"common-pc-header-service",
        label:"A2A決済",
        caption:"連携サービスへ口座から直接支払う",
      }
    ]
  },
  {
    icon:"saving",
    iconPath:savingIcon,
    label:"貯める・管理する",
    caption:"ボックス・レコード",
    childMenu: [
      {
        href:"/service/box/",
        sendSPID:"common-sp-header-service",
        sendPCID:"common-pc-header-service",
        label:"ボックス",
        caption:"目的別に貯められる貯蓄預金",
      },
      {
        href:"/service/record/",
        sendSPID:"common-sp-header-service",
        sendPCID:"common-pc-header-service",
        label:"レコード",
        caption:"お金の出入りを手間なくグラフで把握できる",
      }
    ]
  },
  {
    icon:"advance_money",
    iconPath:advance_moneyIcon,
    label:"借りる・立て替える",
    caption:"ローン・カバー",
    childMenu: [
      {
        href:"/service/loan/",
        sendSPID:"common-sp-header-service",
        sendPCID:"common-pc-header-service",
        label:"ローン",
        caption:"かんたん審査、すべてスマホ完結の「ローン」",
      },
      {
        href:"/service/cover/",
        sendSPID:"common-sp-header-service",
        sendPCID:"common-pc-header-service",
        label:"カバー",
        caption:"後払いサービスのように使える",
      }
    ]
  },
  {
    icon:"thumbs_up",
    iconPath:thumbs_upIcon,
    label:"便利でお得",
    caption:"プレミアムサービス・U25 Z割・提携サービス",
    childMenu: [
      {
        href:"/service/premium/",
        sendSPID:"common-sp-header-service",
        sendPCID:"common-pc-header-service",
        label:"プレミアムサービス",
        caption:"預けるだけ、支払うだけでもっとお得に",
      },
      {
        href:"/service/u25/",
        sendSPID:"common-sp-header-service",
        sendPCID:"common-pc-header-service",
        label:"U25 Z割",
        caption:"25歳以下のみんなが対象のお得なプログラム",
      },
      {
        href:"/alliance-service/",
        sendSPID:"common-sp-header-service",
        sendPCID:"common-pc-header-service",
        label:"提携サービス",
        caption:"パートナー企業のサービスを便利でお得に",
      }
    ]
  },
]

export const RatesMenu =[
    {
      icon:"interestrate",
      iconPath:interestrateIcon,
      href:"/rates/",
      sendSPID:"common-sp-header-ratefee",
      sendPCID:"common-pc-header-ratefee",
      label:"金利",
      caption:"普通預金金利・貯蓄預金金利など",
    },
    {
      icon:"percent",
      iconPath:percentIcon,
      href:"/fees/",
      sendSPID:"common-sp-header-ratefee",
      sendPCID:"common-pc-header-ratefee",
      label:"手数料",
      caption:"ATM手数料・振込手数料など",
    }
  ]


  export const BeginnerMenu = [
    {
      icon:"minna",
      iconPath:minnaIcon,
      href:"/about/",
      sendSPID:"common-sp-header-firsttime",
      sendPCID:"common-pc-header-firsttime",
      label:"みんなの銀行とは",
      caption:"シンプルなお金の管理をスマホで",
    },
    {
      icon:"edit",
      iconPath:editIcon,
      label:"口座開設",
      caption:"スマホでいつでもすぐに口座開設",
      childMenu: [
        {
          href:"/open-account/",
          sendSPID:"common-sp-header-firsttime",
          sendPCID:"common-pc-header-firsttime",
          label:"新規口座の開設",
          caption:"初めて口座開設される方はこちら",
        },
        {
          href:"/open-account/addition/",
          sendSPID:"common-sp-header-firsttime",
          sendPCID:"common-pc-header-firsttime",
          label:"追加口座の開設",
          caption:"すでに口座をお持ちで<br class='show:small'>追加口座を開設される方はこちら",
        }
      ]
      },
    {
      icon:"dictionary",
      iconPath:dictionaryIcon,
      href:"/guide/",
      sendSPID:"common-sp-header-firsttime",
      sendPCID:"common-pc-header-firsttime",
      label:"ユーザーガイド",
      caption:"使い方・活用解説",
    },
    {
      icon:"lock",
      iconPath:lockicon,
      href:"/security/",
      sendSPID:"common-sp-header-firsttime",
      sendPCID:"common-pc-header-firsttime",
      label:"セキュリティ",
      caption:"安心・安全のセキュリティ対策",
    }
  ]

  export const SupportMenu = [
    {
      icon:"help",
      iconPath:helpIcon,
      blank:true,
      href:"https://cs-faq.minna-no-ginko.com/",
      sendSPID:"common-sp-header-support",
      sendPCID:"common-pc-header-support",
      label:"お客さまサポート"
    },
    {
      icon:"chat",
      iconPath:chatIcon,
      href:"/contact/",
      sendSPID:"common-sp-header-support",
      sendPCID:"common-pc-header-support",
      label:"お問合わせ",
    },
    {
      icon:"mobile",
      iconPath:mobileIcon,
      href:"/recovery/",
      column1: true,
      sendSPID:"common-sp-header-support",
      sendPCID:"common-pc-header-support",
      label:"スマートフォンやリアルカードの紛失・盗難",
    },
    {
      icon:"infomation",
      blank:true,
      iconPath:infomationIcon,
      column1: true,
      href:"https://corporate.minna-no-ginko.com/for-safebanking/",
      sendSPID:"common-sp-header-support",
      sendPCID:"common-pc-header-support",
      label:"金融犯罪にご注意ください",
    }
  ]

  export const EffortMenu = [
    {
      column1: true,
      label: '受賞アワード',
      href: '/about/awards/'
    },
    {
      column1: true,
      label: 'みんなでつくる、みんなの銀行プロジェクト',
      href: '/project/'
    },
    {
      label: 'Cheer Box',
      href: '/cheerbox/'
    },
    {
      label: 'アンバサダー',
      href: '/special/ambassador/'
    }
  ]

  export const ContentsMenu = [
    {
      label: 'みんなのマネーコラム',
      href: '/column/'
    },
    {
      label: 'MONEY SAVER',
      href: '/special/moneysaver/'
    },
    {
      label: 'マネータイプ診断',
      href: '/special/moneytype/'
    }
  ]

  export const FooterCommon = {
    company: "スマホ完結のデジタルバンク 株式会社みんなの銀行<br>金融機関コード：0043<br>登録金融機関：福岡財務支局長（登金）第122号<br>加入協会：日本証券業協会",
    copylight: "&copy; Minna Bank, Ltd.",
    policy:{
      label: '利用規約・ポリシー',
      blank:true,
      link:"https://corporate.minna-no-ginko.com/policy-and-term-of-use/"
    },
    footerSNS:[
      {
        link: 'https://x.com/minnano_ginko',
        icon: logo_x,
        alt: "Xロゴアイコン",
      },
      {
        link: 'https://www.facebook.com/minnanoginko',
        icon: logo_facebook,
        alt: "facebookロゴアイコン",
      },
      {
        link: 'https://www.instagram.com/minnano_ginko_official',
        icon: logo_instagram,
        alt: "instagramロゴアイコン",
      },
      {
        link: 'https://www.youtube.com/@minnano_ginko',
        icon: logo_youtube,
        alt: "youtubeロゴアイコン",
      },
      {
        link: 'https://note.minna-no-ginko.com/',
        icon: logo_note,
        alt: "noteロゴアイコン",
      }
    ]
  }
// /business/で使用
  export const BizHeader = [
    {
      label: '特徴',
      href: '#feature'
    },
    {
      label: '口座開設方法',
      href: '#account'
    },
    {
      label: 'みんなの銀行とは',
      href: '#about'
    },
    {
      label: 'お知らせ',
      href: '#news'
    },
    {
      label: 'よくある質問',
      href: '#faq'
    }
  ]
  export const BizFooter = [
    {
      label: '金利・手数料',
      href: '/business/rates-and-fees/'
    },
    {
      label: '会社概要',
      blank:true,
      href: 'https://corporate.minna-no-ginko.com/'
    },
    {
      label: 'お客さまサポート',
      blank:true,
      href: 'https://cs-faq.minna-no-ginko.com/'
    },
    {
      label: 'プレスリリース',
      blank:true,
      href: 'https://corporate.minna-no-ginko.com/information/'
    },
    {
      class: 'nav-link:wide',
      label: '金融犯罪にご注意ください',
      blank:true,
      href: 'https://corporate.minna-no-ginko.com/for-safebanking/'
    }
  ]


  export let videoList = [
    {
      category:"atm",
      videoURL: "dkXjNLRv2vQ",
      label:"ATM",
      title:"夜遅くでも大丈夫！スマホだけで現金を引出せる",
      hashtag:["セブン銀行ATM"]
    },
    {
      category:"cotra",
      videoURL: "C2jtYfYk6ho",
      label:"ことら送金",
      title:"手数料無料で！その場で即送金できる",
      hashtag:["1回あたり10万円以下"]
    },
    {
      category:"invoice",
      videoURL: "Pry8ur-UwU0",
      label:"請求書払い",
      title:"外に出なくてもアプリひとつで！気づいた時にスマホで支払い",
      hashtag:["コンビニ要らず"]
    },{
      category:"record",
      videoURL: "svLaR8OiOu4",
      label:"レコード",
      title:"お金の出入りをまとめて管理！すべての資産をひと目で確認",
      hashtag:["一括管理"]
    },
    {
      category:"box",
      videoURL: "pzllx8xvXOc",
      label:"ボックス",
      title:"生活費を賢く仕分け！挫折しない「目的別貯金」の始め方",
      hashtag:["お金の整理"]
    },{
      category:"debitcard",
      videoURL: "fF1TTlMpa5E",
      label:"デビットカード",
      title:"チケット予約も安心！スマホひとつでスマートに決済する方法",
      hashtag:["JCB"]
    },
    {
      category:"realcard",
      videoURL: "OCHWZ42B5FM",
      label:"リアルカード",
      title:"デジタル×リアルのいいとこ取り！「もしも」に備えるリアルカード",
      hashtag:["JCB"]
    },
    {
      category:"loan",
      videoURL: "UFZSypCALCE",
      label:"ローン",
      title:"大きな出費のピンチ！スマホだけでサクッと借りる方法",
      hashtag:["審査が早い"]
    },
    {
      category:"cover",
      videoURL: "X2OMtSF_7JM",
      label:"カバー",
      title:"デビットカード派の「残高足りない」！そんな悩みもこれで解決",
      hashtag:["自動立替"]
    }
  ];

  export const allCampanyLogoList = [
    {
      href: "/branches/baas-vivion/",
      path: "/assets_default/images/common/logo/logo_dlsite.webp",
      width: "66",
      name: "DLsite",
      a2a: true
    },
    {
      href: "/branches/baas-pixiv/",
      path: "/assets_default/images/common/logo/logo_booth.svg",
      width: "76.787",
      name: "BOOTH",
      a2a: true
    },
    {
      href: "/branches/baas-ignica/",
      path: "/assets_default/images/common/logo/logo_scanandgo.svg",
      width: "39.817",
      name: "Scan＆Go ignica",
      a2a: true
    },
    {
      href: "/branches/baas-supay/",
      path: "/assets_default/images/common/logo/logo_su-pay.svg",
      width: "86.6",
      name: "SU-PAY",
      a2a: true
    },
    {
      href: "/branches/baas-supay/",
      path: "/assets_default/images/common/logo/logo_su-pay_icon.webp",
      width: "40",
      name: "SU-PAY",
      icon: true
    },
    {
      href: "/branches/baas-dmm/",
      path: "/assets_default/images/common/logo/logo_dmm.svg",
      width: "90.584",
      name: "DMM",
      a2a: true
    },
    {
      href: "/branches/baas-mixch/",
      path: "/assets_default/images/common/logo/logo_mixch.svg",
      width: "66.94",
      name: "ミクチャ",
      a2a: true
    },
    {
      href: "/branches/baas-pixiv/",
      path: "/assets_default/images/common/logo/logo_pixiv-coban.svg",
      width: "108.506",
      name: "pixivcoban",
      a2a: true
    },
    {
      href: "/alliance-service/revolut/",
      path: "/assets_default/images/common/logo/logo_revolut.svg",
      width: "80.619",
      name: "Revolut",
      a2a: true
    },
    {
      href: "/branches/baas-mercari/",
      path: "/assets_default/images/common/logo/logo_merpay.svg",
      width: "66.69",
      name: "メルペイ",
      a2a: true
    },
    {
      href: "/branches/baas-gaitame/",
      path: "/assets_default/images/common/logo/logo_gaitame.svg",
      width: "99.531",
      name: "外為どっとコム",
      a2a: true
    },
    {
      href: "/alliance-service/connect/",
      path: "/assets_default/images/common/logo/logo_daiwa-connect.svg",
      width: "106.513",
      name: "大和コネクト証券",
      a2a: true
    },
    {
      href: "/alliance-service/bittrade/",
      path: "/assets_default/images/common/logo/logo_bittrade.svg",
      width: "91.531",
      name: "ビットトレード",
      a2a: true
    },
    {
      path: "/assets_default/images/common/logo/logo_ahara.webp",
      width: "53",
      name: "AHARA",
      a2a: true
    },
    {
      href: "/branches/baas-andst/",
      path: "/assets_default/images/common/logo/logo_andst.svg",
      width: "86.63",
      name: "and ST"
    },
    {
      href: "/branches/baas-tempstaff/",
      path: "/assets_default/images/common/logo/logo_tempstaff.svg",
      width: "99.222",
      name: "パーソルテンプスタッフ"
    },
    {
      href: "/branches/baas-maruzenjunkudo/",
      path: "/assets_default/images/common/logo/logo_maruzen-junkudo.svg",
      width: "67.02",
      name: "丸善ジュンク堂書店"
    },
    {
      href: "/branches/baas-world/",
      path: "/assets_default/images/common/logo/logo_world-staffing.svg",
      width: "114.47",
      name: "ワールドスタッフィング"
    },
    {
      href: "/branches/baas-vivion/",
      path: "/assets_default/images/common/logo/logo_vivion.svg",
      width: "76.27",
      branchW: "132",
      name: "viviON"
    },
    {
      href: "/branches/baas-ande/",
      path: "/assets_default/images/common/logo/logo_tmd.svg",
      width: "88.598",
      name: "東京海上ダイレクト"
    },
    {
      path: "/assets_default/images/alliance-service/index/alliance_logo_msp.webp",
      width: "88.598",
      name: "三井住友海上プライマリー生命保険"
    },
    {
      href: "/branches/baas-pixiv/",
      path: "/assets_default/images/common/logo/logo_pixiv.svg",
      width: "62.716",
      name: "ピクシブ",
      branches: true
    },
    {
      path: "/assets_default/images/common/logo/logo_usmh.svg",
      width: "140",//暫定
      name: "イグニカ",
    },
    {
      path: "/assets_default/images/common/logo/logo_ande.svg",
      width: "98",//暫定
      name: "アンディー",
    }
  ]
